import { useEntitled } from "@authe/ui-core";
import { usePermissions } from "@authe/ui-core/permissions";
import { useRolledOut } from "@authe/ui-core/flags";
import { RESOURCES, ROUTES, visibleNavItems } from "@/config";

/** Offer the same destinations as navigation, without data probes. */
export function useLandingAccess() {
  const { can } = usePermissions();
  const entitled = useEntitled();
  const rolledOut = useRolledOut();
  const destinations = new Set(visibleNavItems(can, entitled, rolledOut).map((item) => item.to));
  return {
    destinations,
    canStartCase: destinations.has(ROUTES.investigations) && can(RESOURCES.investigations, "create"),
  };
}
